<div class="smooth-scrolling">
  <!-- men banner section start -->

  <section class="inner-banner-section">
    <div class="inner-banner-bg-image" [ngStyle]="{'background-image': 'url(' + imagePreview_banner[0] + ')'}">
      <div class="row w-100">
        <div class="col-lg-7 col-md-6 col-sm-8 col-10">
          <div class="inner-banner-content">
            <h2>Men's skin care that beats:</h2>
            <ul class="text-dynamic">
              <li><span>acne</span></li>
              <li><span>dry skin</span></li>
              <li><span>wrinkles</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- men banner section end -->

  <!-- skincare section start -->

  <section class="skincare-section men-skincare-content">
    <div class="mx-825">
      <h4><i>Get your skin in the game</i>
        <b>foy connects you</b>
        <span>with best-in-class skincare</span>
        <i>providers and quality,</i>
        <span>doctor-trusted products</span>
        <i>so you can put your</i>
        <b>best face forward.</b>
      </h4>
    </div>
  </section>

  <!-- skincare section end -->

  <!-- store section start -->

  <section class="store-section store-men-content">
    <div class="store-title text-center">
      <h4><i>What’s in store FOR</i> <b>him</b><i>?</i></h4>
    </div>
    <div class="mx-1200 res-1000">
      <div class="row">
        <div class="col-md-6">
          <div class="store-main-image men-store-content-one">
            <div class="store-main-bg-image">
              <img src="assets/images/store-men-image-1.png" alt="image" />
            </div>
            <div class="store-main-content">
              <h3>skin</h3>
              <p>Lorem ipsum dolor sit amet consectetur. In ac lobortis non id erat morbi.</p>
              <a [href]="'shop-all/1/1'">Shop All</a>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="store-main-image men-store-content-two">
            <div class="store-main-bg-image">
              <img src="assets/images/store-men-image-2.png" alt="image" />
            </div>
            <div class="store-main-content">
              <h3>hair</h3>
              <p>Lorem ipsum dolor sit amet consectetur. In ac lobortis non id erat morbi.</p>
              <a [href]="'shop-all/4/1'">Shop All</a>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="store-main-image men-store-content-three">
            <div class="store-main-bg-image">
              <img src="assets/images/store-men-image-3.png" alt="image" />
            </div>
            <div class="store-main-content">
              <h3>Body</h3>
              <p>Lorem ipsum dolor sit amet consectetur. In ac lobortis non id erat morbi.</p>
              <a [href]="'shop-all/3/1'">Shop All</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- store section end -->

  <!-- skin progress section start -->

  <section class="skin-progress-section" [ngStyle]="{'background-image': 'url(' + imagePreview_skin_banner[0] + ')'}">
    <div class="skin-progress-content">
      <small>check your</small>
      <h4><i>skin</i><br />
        progress</h4>
    </div>
  </section>

  <!-- skin progress section end -->

  <!-- suppliment section start -->

  <section *ngIf="supplimentProducts && supplimentProducts.length > 0" class="suppliment-section">
    <div class="mx-1450">
      <div class="suppliment-image">
        <img
          src="{{imagePreview_suppliment_banner.length > 0 ? imagePreview_suppliment_banner[0] : 'assets/images/suppliment-image-for-him.png'}}"
          alt="image" />
        <span>
          <h4>Supplements <i>For Him</i></h4>
        </span>
      </div>
      <div class="supliment-slider">
        <div class="row justify-content-center">
          <div class="col-lg-4 col-md-6 col-12">
            <div class="face-content sup-content" *ngFor="let supplimentProduct of supplimentProducts">
              <span><img
                  [src]="supplimentProduct.thumbnail_img != null && supplimentProduct.thumbnail_img != '' ? supplimentProduct.thumbnail_img :  'assets/images/default-product.png'"
                  alt="image" /></span>
              <div class="face-tool-content">
                <h5>{{supplimentProduct.name}}</h5>
                <p>
                  <td [innerHTML]="supplimentProduct.description"></td>
                </p>
                <div class="face-price">₹{{supplimentProduct.your_price}}</div>
                <ul>
                  <li><a class="f-bg-black">Quick Shop</a></li>
                  <li><a class="f-border-black">Add to cart</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mt-4">
          <a href="#" class="view-all-btn">View All</a>
        </div>
      </div>
    </div>
  </section>

  <!-- suppliment section end -->


  <!-- trending product section start -->

  <section *ngIf="trendingProducts && trendingProducts.length > 0" class="trending-product-section t-bg-transperant">
    <div class="t-p-title text-center">
      <h4>Trending <i>products</i></h4>
    </div>
    <div class="trending-product-slider">
      <div class="row">
        <div class="col-lg-3 col-md-6" *ngFor="let trendingProduct of trendingProducts">
          <div class="face-content t-p-content">
            <span><img
                [src]="trendingProduct.thumbnail_img != null && trendingProduct.thumbnail_img != '' ?  trendingProduct.thumbnail_img : 'assets/images/default-product.png'"
                alt="image" /></span>
            <div class="face-tool-content">
              <h5>{{trendingProduct.name}}</h5>
              <p>
                <td [innerHTML]="trendingProduct.description"></td>
              </p>
              <div class="face-price">₹{{trendingProduct.your_price}}</div>
              <ul>
                <li><a class="f-bg-black">Quick shop</a></li>
                <li><a class="f-border-black">Add to cart</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center mt-4">
        <a href="#" class="view-all-btn btn-c-white">View all</a>
      </div>
    </div>
  </section>

  <!-- trending product section end -->

  <!-- Footer START -->

  <app-footer-bg></app-footer-bg>

  <!-- Footer END -->
</div>